module.exports = __webpack_public_path__ + "media/images/illustrations/wave-light-1-649d25ba84c86d7e0967f3b9d2131b12.svg";